export const SecurityCodeConstants = {
    Order: "ORDER",
    Shopping: "SHOPPING",
    Individual: "INDIVIDUAL"
}